import "coach/global.css"
import styles from "activities/components/shared.module.css"
import * as env from "util/env"
import "runtime"

import React, {Suspense} from "react"
import ReactDOM from "react-dom"
import * as thm from "activities/theme"
import client from "util/client"
import {ClientContext} from "coach/context"
import Spinner from "activities/components/shared/loading"
import CoachLoading from "coach/loading"
import TitleScreen from "story/title-screen"
import CoachTitleLoading from "story/title-load"
// Import shared functionality
import {
  calculatorsIndex,
  coachTitle,
  createClient,
  appendStyles,
  generateClassComponentMap,
  findTargetElements,
  ClientProvider,
  ErrorBoundary,
  Booting,
  CoachApp
} from "coach/shared-coach"

const _client = createClient()
appendStyles()

// Generate class mappings automatically from index
const classComponentMap = generateClassComponentMap(calculatorsIndex)

// Find all elements to render components into
const items = findTargetElements()

// Wrap client context
const Setup = ({children}) => <ClientProvider client={_client}>{children}</ClientProvider>

// Render components into target elements
items.forEach((element) => {
  const elementId = element.id
  // Check for both ID-based and class-based components
  const componentConfig =
    calculatorsIndex[elementId] ||
    Array.from(element.classList)
      .map((className) => classComponentMap[className])
      .find((config) => config) ||
    coachTitle

  const {type, component} = componentConfig

  switch (true) {
    case env.getMetaContentByName("coach-story") && element.nodeType === 1:
      ReactDOM.render(
        <Setup>
          <Suspense fallback={<CoachTitleLoading />}>
            <CoachApp storyId={elementId} theme={thm.theme} />
          </Suspense>
        </Setup>,
        element
      )
      break

    case type === "activity":
      ReactDOM.render(
        <ErrorBoundary>
          <Setup>
            <Suspense fallback={<Booting styles={styles} />}>
              {React.createElement(component, {
                activityId: elementId || element.className,
                theme: thm.theme
              })}
            </Suspense>
          </Setup>
        </ErrorBoundary>,
        element
      )
      break

    default:
      ReactDOM.render(
        <Setup>
          <Suspense fallback={<CoachTitleLoading />}>{React.createElement(component, {storyId: elementId})}</Suspense>
        </Setup>,
        element
      )
      break
  }
})
